import React from "react";

const Text14 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);

    return(
      <>
        <p className="content-heading" id="top">
          Dina Data
        </p>

      <div className="content-text mt-4">
        
        <p>
          Dina arbetsdata och metadata sparas i Googles molntjänst och är 
          automatiskt tillgängliga under avtalets löptid.       
        </p>    
        <p>
          Arbetsdata sparas automatiskt var 5:e minut – därför bör du även 
          spara manuellt vid avslutat arbetspass, vare sig du väljer Avsluta 
          eller inte.
        </p>
       
      </div>
    </>
  );
}
export default Text14;